// extracted by mini-css-extract-plugin
export default {"imageFitCover":"ImageContainer_imageFitCover__JwJlB","avatarTitle":"ImageContainer_avatarTitle__4pc0b"};